/// <reference path="../../lib/app.d.ts" />

import {TemplateEngine} from "../lib/template-engine";
import {HoverControls} from "../ui/hover-controls";
import {JoinedRoomData} from "../chatserver/sx-server";
import {Translator} from "../utils/translator";
import logging from "../utils/log";
export interface GiftCategory
{
	id : string;
	name : string;
	items : Array<Gift>
	params ?: {
		special ?: any;
	}

	png    ?: string;
	svg    ?: string;

	image ?: string;
}

export interface Gift
{
	id     : string;
	name   : string;

	png    : string;
	svg    : string;

	image ?: string;

	price  : number;
	priceCat : number;

	priceInCurrency ?: number;
	priceInCurrencySize ?: number;

	category: GiftCategory;
}

export class GiftPanel
{
	state: string;
	private TAG = "[GiftPanel]";

	private $picker : JQuery;
	private $sender : JQuery;

	private roomID : string;
	private giftID : string;
	private giftPrice : number;
	private catID : string;

	public onSelect : Function;
	private page : number;
	private currentRoom: JoinedRoomData;
	private hasSmartToy: boolean;
	private screenName: string;

	constructor(
		private $root : JQuery,
		private templateEngine : TemplateEngine,
		private translator : Translator,
		private giftManager : GiftManager,
		private hoverControls : HoverControls)
	{
		this.$root.on("click", ".nav", (e) =>
		{
			let page = $(e.currentTarget).hasClass("right")
				? this.page + 1
				: this.page - 1;

			this.setCatPage(page);
		});

		this.$root.on("click", ".sxcg-category", (e) => {
			let id = $(e.currentTarget).attr("data-id");
			this.pickCategory(id);
		});

		this.$root.on("mouseenter", ".sxcg-gift-item", (e) => {
			let id = $(e.currentTarget).attr("data-id");
			let price = parseInt($(e.currentTarget).attr("data-price"));
			this.hoverGift(id, price);
		});

		this.$root.on("click", ".sxcg-gift-item", (e) => {
			let id = $(e.currentTarget).attr("data-id");
			let price = parseInt($(e.currentTarget).attr("data-price"));
			this.showGift(id, price);
		});

		$(".sxcc-fixed-body").find('.sxcc-gift-item').click((e) => {
			let id = $(e.currentTarget).attr("data-id");
			let price = parseInt($(e.currentTarget).attr("data-price"));
			this.showGift(id, price);
		});

		this.$root.on("click", "button.back", (e) => {
			this.showPicker(this.roomID, this.screenName, this.hasSmartToy, this.catID, this.giftID);
		});

		this.$root.on("click", "button.send", (e) => {
			this.onSelect(this.giftID, this.$root.find("textarea").val(), this.giftPrice);
			this.hide();
		})
	}

	showPicker(roomID : string, screenName : string, hasSmartToy : boolean, catID : string = null, giftID = null)
	{
		logging.log(this.TAG, "showPicker", roomID, screenName, hasSmartToy, catID, giftID);
		this.roomID = roomID;
		this.screenName = screenName;
		this.hasSmartToy = hasSmartToy;

		let $picker = this.templateEngine.render("gift-panel-picker", {
			giftCats : this.getCats(hasSmartToy)
		});

		this.$root.find(".sxcg-list-wrapper").sxcCustomScroll("destroy");

		this.$root
			.empty()
			.append($picker)
			.addClass("sxc-visible");

		this.$root.find(".sxcg-list-wrapper").sxcCustomScroll("init");

		this.setCatPage(0);
		this.pickCategory(catID ? catID : "_tip");
		const gift = this.giftManager.getByID(giftID ? giftID : catID ? catID : "_tip");
		this.hoverGift(gift.id, gift.price);
		this.state = "picker";
	}

	showGift(giftID : string, giftPrice : number = null)
	{
		logging.log(this.TAG, "showGift", giftID, giftPrice);

		const gift = this.giftManager.getByID(giftID);
		const isTip = gift.category.id === "_tip";

		this.giftID = giftID;
		this.giftPrice = giftPrice ? giftPrice : gift.price;

		let $panel = this.templateEngine.render("gift-panel-sender", {
			gift : gift,
			isTip : isTip
		});

		this.$root.find(".sxcg-list-wrapper").sxcCustomScroll("destroy");

		this.$root
			.empty()
			.append($panel)
			.addClass("sxc-visible");

		this.hoverGift(giftID, giftPrice);
		this.state = "gift";
	}

	setCatPage(page : number)
	{
		const list = this.getCats(this.hasSmartToy);
		const onePageItems = 6;
		const maxPages = Math.ceil(this.getCats(this.hasSmartToy).length / onePageItems);

		this.page = page;
		if (this.page > maxPages - 1) this.page = 0;
		if (this.page < 0) this.page = maxPages - 1;

		this.$root.find(".sxcg-categories").empty();

		let first = this.page * onePageItems;
		let last = (this.page + 1) * onePageItems - 1;

		if (last > list.length - 1) {
			last = list.length - 1;
			first = list.length - onePageItems;
		}

		for (let i=first; i<=last; i++)
		{
			let cat = list[i];
			let $item = $("<div class='sxcg-category sxc-tooltip-container'/>")
				.attr("data-id", cat.id)
				.append(
					$("<button />").append(
						$("<img />").attr("src", cat.image)
					),
					$("<div class='sxc-tooltip sxc-tooltip-top-center sxc-tooltip-color-blue sxc-tooltip-size-small' />")
						.text(cat.id === "_tip"
							? this.translator.t("gift_tip_category")
							: cat.name)
				);

			if (this.catID == cat.id) {
				$item.addClass("sxc-active");
			}

			this.$root.find(".sxcg-categories").append($item);
		}
	}

	private hoverGift(giftID : string, giftPrice : number)
	{
		const gift = this.giftManager.getByID(giftID);

		const price = giftPrice ? giftPrice : gift.price;

		console.log(gift);

		const isTip = gift.category.id === "_tip";
		const isSmartToy = gift.category.params && gift.category.params.special && gift.category.params.special === "ohMiBod";

		this.$root.find(".sxcgh-icon img").attr("src", gift.image);
		this.$root.find(".sxcgh-credits").text(price + " " + this.translator.t("__currency"));
		this.$root.find(".tip-price")
			[isTip ? "show" : "hide"]()
			.attr("data-size", price.toString().length)
			.text(price);


		if ("priceCat" in gift) this.$root.find(".sxcgh-icon").attr("data-pcat", gift["priceCat"]);

		this.$root.find(".sxcg-header")[isSmartToy ? "addClass" : "removeClass"]("sxcgh-zzz");
	}

	private pickCategory(catID : string)
	{
		const list = this.getCats(this.hasSmartToy);
		this.catID = catID;

		this.$root.find(".sxcg-category").removeClass("sxc-active");
		this.$root.find(".sxcg-category[data-id=" + catID + "]")
			.addClass("sxc-active");

		let selectedCat;
		for (let i=0; i < list.length; i++) {
			if (list[i].id === catID) {
				selectedCat = list[i];
				break;
			}
		}

		if (!selectedCat) return;

		this.$root.find(".sxcg-list").empty();

		for (let item of selectedCat.items)
		{
			let $item = $("<div class='sxcg-gift-item' />")
				.attr("data-id", item.id)
				.attr("data-price", item.price)
				.append(
					$("<button />").append(
						$("<img />").attr("src", item.image)
					)
				);

			if (catID === "_tip")
			{
				$item.find("button")
					.append(
						$("<div class='price' />")
							.text(item.price)
							.addClass("price-" + item.price.toString().length)
					);
			}

			this.$root.find(".sxcg-list").append($item);
		}

		if (catID === "_tip")
		{
			for (let item of this.giftManager.getSuggestions())
			{
				let $item = $("<div class='sxcg-gift-item' />")
					.attr("data-id", item.id)
					.attr("data-price", item.price)
					.append(
						$("<button />").append(
							$("<img />").attr("src", item.image)
						)
					);

				this.$root.find(".sxcg-list").append($item);
			}
		}

		this.$root.find(".sxcg-list-wrapper").sxcCustomScroll("update");

		// for (let cat of this.getCats().length) {
		// 	if (catID === cat.id) {
		// 		selectedCat;
		// 		break;
		// 	}
		// }
		//
		// let $items = this.templateEngine.render("gift-panel", {
		// 	gifts : items
		// });
		//
		// this.$root.find(".sxcg-list")
		// 	.empty()
		// 	.append($items);

		const gift = selectedCat.items[0];
		this.hoverGift(gift.id, gift.price);
	}

	/**
	 * Returns a sanitized list of categories used by this module
	 */
	private getCats(hasSmartToy : boolean)
	{
		let giftCats = this.giftManager.getCategories();

		giftCats = giftCats.map((cat) =>
		{
			cat.items = cat.items.map((item) => {
				item.priceInCurrency = item.price;
				item.priceInCurrencySize = item.price.toString().length;
				return item;
			});
			return cat;
		});

		giftCats = giftCats.filter((cat) =>
		{
			if (!cat.params) return true;
			if (cat.params && !cat.params.special) return true;
			if (cat.params && cat.params.special === "ohMiBod" && hasSmartToy) return true;

			return false;
		});

		return giftCats;
	}

	hide()
	{
		logging.log(this.TAG, "hide");
		this.$root.removeClass("sxc-visible");
	}

	isVisible() : boolean {
		return this.$root.hasClass("sxc-visible");
	}

	esc()
	{
		logging.log(this.TAG, "esc");
		if (this.state == "picker") {
			this.hide();
		} else {
			this.showPicker(this.roomID, this.screenName, this.hasSmartToy, this.catID, this.giftID);
		}
	}

	public performerChanged(perf : JoinedRoomData)
	{
		this.currentRoom = perf;
	}
}


export class GiftManager
{
	private gifts : Array<Gift>;
	private giftCats : Array<GiftCategory>;
	private imageBase : string;
	private suggestions : string[];
	private smarttoys : string[];

	constructor(private params : any)
	{
		this.giftCats = params.list;
		this.imageBase = params.root;
		this.suggestions = params.suggestions;
		this.smarttoys = params.smarttoys;

		let tipItems = [50, 100, 150, 200, 500, 750, 1000, 2000, 5000, 10000];

		let tipCat = {
			id: "_tip",
			isTip: true,
			name: "",
			items: [],
			png: "_tip_coin.png",
			svg: "_tip_coin.svg"
		};

		for (let ti of tipItems) {
			tipCat.items.push({
				price: ti,
				name: "",
				id: "_tip",
				png: "_tip_coin.png",
				svg: "_tip_coin.svg"
			});
		}

		this.giftCats.unshift(tipCat);

		let svgSupport : boolean = typeof SVGRect != "undefined";

		for (let cat of this.giftCats)
		{
			cat.png = "gift_category_" + cat.id + ".png";
			cat.svg = "gift_category_" + cat.id + ".svg";

			let image = svgSupport ? (cat.svg ? cat.svg : cat.png) : cat.png;
			cat.image = this.imageBase + image;

			for (let item of cat.items) {
				item.category = cat;
			}
		}

		this.giftCats.sort((a, b) => {
			let aw = a.id === "_tip" ? 3 : (a.id === "ohmibod" ? 2 : 1);
			let bw = b.id === "_tip" ? 3 : (b.id === "ohmibod" ? 2 : 1);
			return bw - aw;
		});

		this.gifts = [];
		for (let i = 0; i < this.giftCats.length; i++) {
			this.gifts = this.gifts.concat(this.giftCats[i].items);
		}


		for (let gift of this.gifts) {
			let image = svgSupport ? (gift.svg ? gift.svg : gift.png) : gift.png;
			gift.image = this.imageBase + image;
		}

		// Precache. Stupid edition :)

		let cacheFn = (image) => {
			let random = 10000 + Math.random() * 10000;
			setTimeout(() => {
				let img = document.createElement("img");
				img.src = image;
				let removeFn = ((img) =>{return () => img.parentNode.removeChild(img)})(img);
				img.onload = removeFn;
				img.onerror = removeFn;
				img.style.position = "absolute";
				img.style.top = "-1px";
				img.style.left = "-1px";
				img.style.width = "1px";
				img.style.height = "1px";
				document.body.appendChild(img);
			}, random);
		};
	}

	getByID(id : string) : Gift
	{
		for (let i = 0; i < this.gifts.length; i++) {
			if (this.gifts[i].id == id) return this.gifts[i];
		}

		return null;
	}

	getSuggestions() : Gift[]
	{
		return this.suggestions.map((i) => {
			return this.getByID(i);
		})
	}

	getSmartToysGifts() : Gift[]
	{
		return this.smarttoys.map((i) => {
			return this.getByID(i);
		})
	}

	getRandom() : Gift {

		let filtered = this.gifts.filter((gift : Gift) => {
			return !!gift.svg;
		});

		let id = Math.floor(Math.random() * filtered.length);
		return filtered[id];

		// let id = Math.floor(Math.random() * this.gifts.length);
		// return this.gifts[id];
	}

	getCategory(id : string) : GiftCategory
	{
		for (let i = 0; i < this.giftCats.length; i++) {
			if (this.giftCats[i].id == id) return this.giftCats[i];
		}

		return null;
	}

	getList() : Array<Gift>
	{
		return this.gifts;
	}

	getCategories() : Array<GiftCategory>
	{
		return this.giftCats;
	}

	getSpecials()
	{

	}
}

export class GiftLayer
{
	private TAG = "[Sxc.Chat.GiftView]";

	// Stores whether the last gift was put on the right side or not.
	private lastRightSide : boolean;

	constructor(private $root, private giftManager : GiftManager)
	{

	}

	flash(id : string)
	{
		let gift = this.giftManager.getByID(id);

		if (!gift) {
			console.warn(this.TAG, "[flash]", "Gift", id, "not found");
			return;
		}

		let size;

		if (gift.price <= 100) size = 0.25;
		else if (gift.price <= 1000) size = 0.35;
		else if (gift.price <= 5000) size = 0.55;
		else size = 0.8;

		// Randomize position.
		let posX : number, posY : number, rightSide : boolean, minDistance : number;
		let padding = 0.07;
		let retry = 100;

		rightSide = this.lastRightSide === null
			? !!Math.floor(Math.random() * 2)
			: !this.lastRightSide;

		this.lastRightSide = rightSide;


		do {
			// Calc new position
			posY = Math.random() * (1 - padding) + padding;
			posX = Math.random() * (0.2 - padding) + padding;
			if (rightSide) posX = 1 - posX;

			// See if this is close to other gifts
			minDistance = null;

			this.$root.find(".sxcc-gift-popup").each((i, item) =>
			{
				let $item = $(item);
				let itemX = parseFloat($item.data("posx")) || 0;
				let itemY = parseFloat($item.data("posy")) || 0;
				let d = Math.sqrt(Math.pow(itemX - posX, 2) + Math.pow(itemY - posY, 2));
				if (minDistance === null || minDistance > d) minDistance = d;
			});

			// Exit if far enough, retry if close
			if (minDistance === null || minDistance > 0.15) retry = 0;
			else retry--;

		} while (retry);

		let $image = $("<img />");
		let $gift =  $("<div class=\"sxcc-gift-popup\"/>")
			.data("posx", posX)
			.data("posy", posY)
			.data("size", size)
			.append($image)
			.appendTo(this.$root);

		let tmp = window.getComputedStyle($gift[0]).opacity;

		$image.on("load", () => {
			$gift.addClass("sxc-visible");

			let r = Math.random() * 70 - 35;
			$gift.find("img").css("transform", "rotate(" + r + "deg)");

			this.adjust($gift);


			setTimeout(() => {
				$gift.addClass("sxc-phase-out");
				setTimeout(() => {
					$gift.remove();
				}, 1000)
			}, 4000)
		});

		let isSVG = /\.svg$/.test(gift.image);

		if (!isSVG) {
		//	$image.css("outline", "1px solid red");
		}

		$image.attr("src", gift.image);
	}

	public resize()
	{
		this.$root.find(".sxcc-gift-popup").each((i, item) => {
			this.adjust($(item));
		});
	}

	private adjust($gift : JQuery)
	{
		let posX = parseFloat($gift.data("posx")) || 0;
		let posY = parseFloat($gift.data("posy")) || 0;
		let size = parseFloat($gift.data("size")) || 0;

		let cntW = this.$root.width();
		let cntH = this.$root.height();

		size = cntH * size;

		let left = posX * cntW - size * posX;
		let top = posY * cntH - size * posY;

		$gift.css({
			width: size,
			height: size,
			top: top,
			left: left
		});
	}

	clear() : void
	{
		this.$root.find(".sxcc-gift-popup").remove();
	}
}
